// ".multi-circle-slider" and "".single-circle-slider" class respecitvely if these need to be broken up in the future
const circleSliderSections = document.querySelectorAll( ".circle-slider" );

circleSliderSections.forEach( ( section ) => {
  // console.log(section);
  const sliderDiv = section.querySelector( ".slider" );
  const slides = section.querySelectorAll( " .slide" );
  const controlsContainer = section.querySelector( ".slider-controls" );
  // console.log(controlsContainer);
  const numSlidesLg = sliderDiv.dataset.cols || 3;
  // 4 circles need real room (fixed diameter + text), so they only switch
  // from one-at-a-time to a row at the "xl" breakpoint (1200px) instead of
  // "md" (768px); the circle's own size/font classes switch at the same
  // point (xl: instead of lg:) in multi-circle-slider.blade.php. 2-3
  // columns keep the original 768px breakpoint.
  const itemsBreakpoint = numSlidesLg >= 4 ? 1200 : 768;

  if ( sliderDiv && slides.length > 0 ) {
    const overflowSlider = tns( {
      container: sliderDiv,
      autoplay: false,
      nav: false,
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: controlsContainer,
      speed: 500,
      gutter: 36,
      items: 1,
      responsive: {
        [ itemsBreakpoint ]: {
          gutter: 12,
          items: numSlidesLg,
        },
      },
    } );
  }
} );
